import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { publicPageFromPath } from './app/publicRoutes'
import './app/global.css'

const root = createRoot(document.getElementById('root')!)
const publicPage = publicPageFromPath(window.location.pathname)

if (publicPage) {
  void import('./features/public-info/PublicApp').then(({ PublicApp }) => {
    root.render(<StrictMode><PublicApp page={publicPage} /></StrictMode>)
  })
} else {
  void import('./app/App').then(({ App }) => {
    root.render(<StrictMode><App /></StrictMode>)
  })
}
